import React from 'react';
import { Button, Modal, ModalHeader, Input, FormGroup, Label } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import { filterDuplicatesById } from 'services/DataFormatters';
import { isValueEntered } from 'services/Validation';

class AddSurveyGroupQuestion extends React.Component {
    constructor(props) {
        super(props);

        const { id } = props.surveyGroupQuestion;
        this.state = {
            id,
            idValid: isValueEntered(id),
            formErrors: { id: '' },
            formValid: false
        };
    }

    componentDidMount() {
        this.validateForm();
    }

    validateForm() {
        this.setState({ formValid: this.state.idValid });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let idValid = this.state.idValid;

        switch (fieldName) {
            case 'id':
                idValid = isValueEntered(value);
                fieldValidationErrors.name = idValid ? '' : ' is invalid';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            idValid: idValid,
        }, this.validateForm);
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState(
            { [name]: value },
            () => { this.validateField(name, value); } // run this call back on state change
        );
    }

    render() {
        const {
            onSaveSurveyGroupQuestion,
            showSurveyGroupLoader,
            onSurveyGroupQuestionClose,
            open,
            surveyQuestions,
            surveyGroup } = this.props;
        const { id } = this.state;
        const filteredSurveyQuestions = filterDuplicatesById(surveyQuestions, surveyGroup?.questions);
        return (
            <Modal className="modal-box" toggle={onSurveyGroupQuestionClose} isOpen={open}>
                <ModalHeader className="modal-box-header bg-primary">
                    <IntlMessages id="surveyGroupQuestion.addSurveyGroupQuestion" />
                    <span className="text-white pointer">
                        <i className="zmdi zmdi-close zmdi-hc-lg" onClick={onSurveyGroupQuestionClose} />
                    </span>
                </ModalHeader>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        <div className="col-lg-9 d-flex flex-column order-lg-1">
                            <FormGroup>
                                <Label for="questionSelect">Select</Label>
                                <Input type="select" name="id" id="questionSelect" onChange={(event) => this.handleUserInput(event)}>
                                    <option key='emptySelect' value=''>-- select question --</option>
                                    {filteredSurveyQuestions.map((surveyQuestion) => {
                                        return <option key={surveyQuestion.id} value={surveyQuestion.id}>{surveyQuestion.name}</option>;
                                    })}
                                </Input>
                            </FormGroup>
                        </div>
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    <Button className="text-uppercase" disabled={!this.state.formValid} color="primary" onClick={() => {
                        showSurveyGroupLoader();
                        onSurveyGroupQuestionClose();
                        onSaveSurveyGroupQuestion(
                            {
                                'id': id,
                            });
                        this.setState({
                            id: '',
                            formErrors: { id: '' },
                            formValid: false
                        });
                    }}>
                        <IntlMessages id="surveyGroupQuestion.addSurveyGroupQuestion" /></Button>
                </div>
            </Modal>
        );
    }
}

export default AddSurveyGroupQuestion;


// WEBPACK FOOTER //
// ./components/Agile/SurveyGroupQuestion/AddSurveyGroupQuestion/index.js